import { Injectable, inject } from '@angular/core';
import { TicketFilter } from '../data/ticket-filter.model';
import { ResolveFn } from '@angular/router';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TICKET_FILTER } from '../ticket.shared';
import { TicketFilterStore } from '../ticket.shared';

export const ticketFiltersResolver: ResolveFn<TicketFilter[]> = async (route) => {
  const store = inject(Store);

  return store.dispatch(
    SOFTLINE_FEATURE_TICKET_FILTER,
    TicketFilterStore.actions.loadMany,
    { clear: true }
  );
};
